<div *ngIf="settingsPopupOpen" class="modal">
  <div class="settings-popup">
    <div class="settings-header">
      <span class="settings-header-title"><i class="fa-sharp fa-solid fa-gear"></i> Settings</span>
      <div (click)="closePopup()" class="settings-header-exit"><i class="fas fa-times"></i></div>
    </div>
    <div class="settings-content">
      <app-field-wrapper labelsWidth="250px">
        <ng-container *ngIf="!isDev">
          <app-generic-field [label]="'Frontend Version: '">
            <div class="container" [tabindex]="0">
              <div class="text">
                <ng-container *ngIf="frontEndVersion">FR#{{frontEndVersion}}</ng-container><ng-container *ngIf="frontEndVersion">#{{frontEndBuildNumber}}</ng-container></div>
            </div>
          </app-generic-field>
          <ng-container *ngIf="desktopWrapperVersionAndBuildNumber">
            <app-generic-field [label]="'Desktop Version: '">
              <div class="container" [tabindex]="0">
                <div class="text">DW#{{desktopWrapperVersionAndBuildNumber}}</div>
              </div>
            </app-generic-field>
          </ng-container>
        </ng-container>
        <w-boolean-field label="Enable emails:" [(value)]="settings.email.emailEnabled"></w-boolean-field>
        <w-boolean-field label="Receive assignment emails:" *ngIf="settings.email.emailEnabled" [(value)]="settings.email.receiveAssignmentEmails"></w-boolean-field>
        <w-boolean-field label="Receive comment emails" *ngIf="settings.email.emailEnabled" [(value)]="settings.email.receiveCommentEmails"></w-boolean-field>
        <w-boolean-field label="Receive mention emails" *ngIf="settings.email.emailEnabled" [(value)]="settings.email.receiveMentionEmails"></w-boolean-field>
<!--        <w-dropdown-field label="Language:"-->
<!--                          [(value)]="settings.language" [options]="availableLanguages"></w-dropdown-field>-->
<!--        <w-dropdown-field label="Themes:"-->
<!--                          [(value)]="settings.theme" [options]="availableThemes"></w-dropdown-field>-->
      </app-field-wrapper>
    </div>
    <button class="save-button" (click)="saveSettings()"> Save </button>
  </div>
</div>
